import EmblaCarousel from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Autoplay from 'embla-carousel-autoplay'

const Slideshows = document.querySelectorAll('.Slideshow-wrapper')

let activeSlideshow = null
let activeEmblaApi = null

function handleKeyDown(event) {
  if (!activeSlideshow || !activeEmblaApi) return

  if (event.code === 'ArrowLeft') {
    event.preventDefault()
    activeEmblaApi.scrollPrev()
  } else if (event.code === 'ArrowRight') {
    event.preventDefault()
    activeEmblaApi.scrollNext()
  }
}

window.addEventListener('keydown', handleKeyDown)

if (Slideshows) {
  Array.prototype.forEach.call(Slideshows, function (slideshowElement) {
    let options = { loop: true }
    let plugins = [WheelGesturesPlugin()]

    if (slideshowElement.getAttribute('data-autoplay') == 'true') {
      options = { loop: true, playOnInit: true }
      plugins = [
        WheelGesturesPlugin(),
        Autoplay({
          playOnInit: true,
          delay: 6000,
          stopOnMouseEnter: true,
          stopOnInteraction: false,
        }),
      ]
    }

    const emblaApi = EmblaCarousel(slideshowElement, options, plugins)

    const prevButtonNode = slideshowElement.querySelector(
      '.Slideshow-button--prev',
    )
    const nextButtonNode = slideshowElement.querySelector(
      '.Slideshow-button--next',
    )

    if (prevButtonNode)
      prevButtonNode.addEventListener('click', emblaApi.scrollPrev, false)
    if (nextButtonNode)
      nextButtonNode.addEventListener('click', emblaApi.scrollNext, false)

    // IntersectionObserver für Sichtbarkeit
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          activeSlideshow = slideshowElement
          activeEmblaApi = emblaApi
        } else if (activeSlideshow === slideshowElement) {
          activeSlideshow = null
          activeEmblaApi = null
        }
      },
      { threshold: 0.5 },
    )

    observer.observe(slideshowElement)
  })
}

const SlideshowCaptionButtons = document.querySelectorAll(
  '.Slideshow-itemCaptionButton',
)

if (SlideshowCaptionButtons) {
  Array.prototype.forEach.call(
    SlideshowCaptionButtons,
    function (captionButtonElement) {
      captionButtonElement.addEventListener('click', () => {
        const itemElement = document.querySelector(
          '#' + captionButtonElement.getAttribute('aria-controls'),
        )

        if (
          !captionButtonElement.getAttribute('aria-expanded') ||
          captionButtonElement.getAttribute('aria-expanded') == 'false'
        ) {
          captionButtonElement.setAttribute('aria-expanded', true)
          itemElement.classList.add('Slideshow-item--captionExpanded')
        } else {
          captionButtonElement.setAttribute('aria-expanded', false)
          itemElement.classList.remove('Slideshow-item--captionExpanded')
        }
      })
    },
  )
}
